import React, { useState } from "react";
import CourseService from "../../services/CourseService";
import { useQuery } from "@tanstack/react-query";
import { Card, CardBody, CardImg, Col, Container, Row } from "reactstrap";
import { imageBaseApi } from "../../services/imageBaseApi";
import SectionContainer from "../../Homepage/SectionContainer";
import { Link, useNavigate } from "react-router-dom";
import fallbackImage from "../../assets/kangaroo/noImage.jpeg"

const Courses = () => {
  const navigate = useNavigate();
  const fetchCourses = async () => {
    const response = await CourseService.getList();
    console.log("🚀 ~ fetchCourses ~ response:", response);
    return response;
  };

  const {
    isPending,
    error,
    data: courseData,
  } = useQuery({
    queryKey: ["courseList"],
    queryFn: fetchCourses,
  });
  if (isPending) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;
  return (
    <SectionContainer>
      <div className="main-container py-5">
        {courseData?.map((section) => (
          <div key={section.id} className=" py-3">
            <h4 className=" font-level-7" style={{ color: "#7A7E8E", marginBottom: "5rem" }}>
              {section.headingName}
            </h4>
            <Row className="">
              {section.courses?.map((course) => (
                <Col key={course.id} lg="4" md="6" className="mb-5">
                  <small className="country-paragraph-text" style={{ color: "#7A7E8E" }} >
                    Course Code: {course.courseCode}
                  </small>
                  <div className="mb-3">

                    <Link to={`/course/${course.id}`} className="text-decoration-none">

                      <Card

                        style={{
                          // width: "100%",
                          // height: "250px",
                          overflow: "hidden",
                          cursor: "pointer",
                          marginTop: "0.55rem",

                          // display: "flex",
                          // alignItems: "center",
                          // justifyContent: "center",
                          border: "none",
                        }}
                      >
                        <CardImg
                          src={
                            course?.bannerMedia?.url
                              ? `${imageBaseApi}${course.bannerMedia.url}`
                              : fallbackImage
                          }
                          style={{
                            width: "100%",
                            height: "200px",
                            objectFit: "cover",
                            marginBottom: "0.55rem"
                          }}
                        />
                        <CardBody className="p-0">
                          <h6
                            className="font-level-7"
                          >
                            {course.name}
                          </h6>
                        </CardBody>
                      </Card>
                    </Link>

                  </div>
                </Col>
              ))}
              <hr className="text-muted mt-4 mb-4" />
            </Row>
          </div>
        ))}
      </div>
    </SectionContainer>
  );
};

export default Courses;
